import { render, staticRenderFns } from "./Embarazada.vue?vue&type=template&id=4a08ce56&scoped=true&"
import script from "./Embarazada.vue?vue&type=script&lang=js&"
export * from "./Embarazada.vue?vue&type=script&lang=js&"
import style0 from "./Embarazada.vue?vue&type=style&index=0&id=4a08ce56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08ce56",
  null
  
)

export default component.exports